import { Image as ChakraImage, type ImageProps as ChakraImageProps } from '@chakra-ui/react';
import NextImage, { type ImageProps as NextImageProps } from 'next/image';
import { forwardRef } from 'react';

export type ImageProps = NextImageProps & Omit<ChakraImageProps, 'src' | 'width' | 'height'>;

export const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(props, ref) {
  const {
    children,
    src,
    width,
    height,
    alt,
    loader,
    fill,
    sizes,
    quality,
    priority,
    placeholder,
    style,
    onLoad,
    onError,
    blurDataURL,
    overrideSrc,
    unoptimized,
    ...rest
  } = props;

  return (
    <ChakraImage {...rest} asChild>
      <NextImage
        ref={ref}
        src={src}
        width={width}
        height={height}
        alt={alt}
        loader={loader}
        fill={fill}
        sizes={sizes}
        quality={quality}
        priority={priority}
        placeholder={placeholder}
        style={style}
        onLoad={onLoad}
        onError={onError}
        blurDataURL={blurDataURL}
        overrideSrc={overrideSrc}
        unoptimized={unoptimized}
      />
    </ChakraImage>
  );
});
